// @ts-nocheck
//FIXME: fix the types in the api
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Field } from "../pages/Orders/api/OrdersApi";
import { getQueryParams } from "../utils/getQueryParams";
import { has, hasIn } from "cypress/types/lodash";
import { data } from "cypress/types/jquery";
// import { kebabToCamel } from "../utils/kebabToCamel";
// Create a new event
export const UserLoginRequiredEvent = new Event("UserLoginRequired");

function kebabToCamel(kebabString: string): string {
	return kebabString.replace(/-([a-z])/g, function (g) {
		return g[1].toUpperCase();
	});
}
export default kebabToCamel;

const fullHostName = window.location.hostname.toUpperCase();
const hostName = fullHostName.split(".");
const host = "VITE_API_" + hostName[0];
let base_url = import.meta.env[host];
if (base_url == undefined) {
	base_url = import.meta.env.VITE_API;
}

export interface OptionsType {
	transactionId?: string;
	fields?: (
		| string
		| Field
		| { location: string[]; shipToAddress: string[] }
	)[];
	sort?: any;
	slug?: string;
	id?: string;
	join?: Array<{ [key: string]: { [key: string]: string } }>;
	where?: {
		[key: string]: any;
		and?: (string | Record<string, any>)[];
		or?: (string | Record<string, any>)[];
	};
	recordsPerPage?: number;
	page?: number;
}
export interface BaseDataItem extends Row {
	index: number;
	slug: string;
	field: string;
	name: string;
	isVisible: boolean;
}

interface Meta {
	depth: number;
	page: number;
	prevPage: number | null;
	nextPage: number;
	totalPageCount: number;
}

interface Data {
	uuid: string;
	manufacturer: string;
	description: string;
	modelNumber: string;
	assetType: string;
}

interface Row {
	data: Data;
	nested: Nested;
}

interface Nested {
	meta: Meta;
	rows: Row[];
}

export interface DataTableDataType {
	meta: Meta;
	data: BaseDataItem[];
	rows: BaseDataItem[];
}
export interface DataTableMetaType {
	fields: Array<{
		field: string;
		slug: string;
	}>;
	table: {
		uuid: string;
		recordsPerPage: number;
		slug: string;
		name: string;
		route: string;
		fields: any;
	} | null;
}

export interface DataTableFieldMetaType {
	field: string;
	index: number;
	isVisible: boolean;
	isSortable: boolean;
	isFilterable: boolean;
	slug: string;
	name: string;
	type: string;
	precision: number;
	recordRoute: string;
	selectIdentifierField: string;
	selectNameField: string;
}

export interface ConditionType {
	"="?: any;
	"<"?: any;
	">"?: any;
}

export interface TableViewGroup {
	uuid: string;
	slug: string;
}

localStorage.setItem("hostName", hostName[0]);

export const togaApiRequest = async (
	method: "GET" | "POST" | "PUT" | "DELETE",
	route: string,
	payload: object | null = null,
	options: OptionsType = {},
) => {
	let retry;
	let response;
	const isAuthenticationRequest = route.includes("/auth");
	do {
		retry = false;
		const header = await initialize(isAuthenticationRequest);
		options["transactionId"] = uuidv4();
		let url = "";
		if (route.includes("?")) {
			url = base_url + route + "&" + assembleOptions(options);
		} else {
			url = base_url + route + "?" + assembleOptions(options);
		}

		try {
			switch (method) {
				case "GET":
					response = await axios.get(url, {
						headers: header,
						params: payload,
						validateStatus: function (status) {
							return status >= 200 && status < 500;
						},
					});

					break;
				case "POST":
					response = await axios.post(url, payload, {
						headers: header,
						validateStatus: function (status) {
							return status >= 200 && status < 500;
						},
					});
					break;
				case "PUT":
					response = await axios.put(url, payload, {
						headers: header,
						validateStatus: function (status) {
							return status >= 200 && status < 500;
						},
					});
					break;
				case "DELETE":
					response = await axios.delete(url, {
						headers: header,
						params: payload,
						validateStatus: function (status) {
							return status >= 200 && status < 500;
						},
					});
					break;
			}

			if (response.status === 401) {
				if (route.includes("/auth/refresh")) {
					handleLogout();
				} else {
					localStorage.setItem("accessToken", "");
					retry = true;
				}
			}
		} catch (error) {
			Sentry.captureMessage("Api Error", {
				level: "warning",
				tags: {
					errorType: "API",
					authentication: "failed",
				},
				extra: error,
			});
			break;
		}
	} while (retry);
	return response ? response.data : null;
};

export const initialize = async (isAuthenticationRequest: boolean) => {
	let isNewUserLoginRequired = false;
	if (!isAuthenticationRequest) {
		do {
			if (
				localStorage.getItem("accessToken") == undefined ||
				localStorage.getItem("accessToken") == ""
			) {
				if (
					localStorage.getItem("refreshToken") == undefined ||
					localStorage.getItem("refreshToken") == ""
				) {
					const response = await togaApiRequest(
						"POST",
						"/auth/public",
					);
					if (response.isSuccess) {
						localStorage.setItem(
							"accessToken",
							response.data.tokens.access,
						);
						localStorage.setItem(
							"refreshToken",
							response.data.tokens.refresh,
						);
					} else {
						Sentry.captureMessage("Public Token", {
							level: "warning",
							tags: {
								errorType: "API",
							},
							extra: response,
						});
					}
				} else {
					const response = await togaApiRequest(
						"POST",
						"/auth/refresh",
					);
					if (response.isSuccess) {
						localStorage.setItem(
							"accessToken",
							response.data.tokens.access,
						);
					} else if (response.status == 401) {
						handleLogout();
						isNewUserLoginRequired = true;
					}
				}
			}
		} while (
			!isNewUserLoginRequired &&
			(localStorage.getItem("accessToken") == undefined ||
				localStorage.getItem("accessToken") == "")
		);
	}

	if (isNewUserLoginRequired) {
		window.dispatchEvent(UserLoginRequiredEvent);
	} else {
		let header: { "Content-Type": string; Authorization?: string } = {
			"Content-Type": "application/json",
		};

		let bearerToken = null;
		if (
			localStorage.getItem("accessToken") !== undefined &&
			localStorage.getItem("accessToken") !== ""
		) {
			bearerToken = localStorage.getItem("accessToken");
		} else if (
			localStorage.getItem("refreshToken") !== undefined &&
			localStorage.getItem("refreshToken") !== ""
		) {
			bearerToken = localStorage.getItem("refreshToken");
		}

		if (bearerToken) {
			header.Authorization = `Bearer ` + bearerToken;
		}

		return header;
	}
};

const handleLogout = () => {
	localStorage.setItem("theme", "togaSupply");
	localStorage.removeItem("accessToken");
	localStorage.removeItem("refreshToken");
	localStorage.removeItem("darkMode");
	localStorage.removeItem("user");
	window.location.href = "/";
	window.location.reload();
};

export function checkUserLoggedIn() {
	if (
		localStorage.getItem("accessToken") === undefined ||
		localStorage.getItem("accessToken") === null
	) {
		return false;
	}

	const jwtParts = localStorage.getItem("accessToken")?.split(".");
	const decodedJwt = jwtParts ? JSON.parse(atob(jwtParts[1])) : null;
	if (decodedJwt.id.hasOwnProperty("client")) {
		if (decodedJwt.id.client.hasOwnProperty("user")) {
			if (decodedJwt.id.client.user.hasOwnProperty("id")) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	} else {
		return false;
	}
}

interface Options {
	fields?: any;
	where?: any;
	join?: any;
	ojoin?: any;
	sort?: any;
	[key: string]: any;
}

function assembleOptions(options: Options): string {
	let queryString = new URLSearchParams();
	for (let optionKey in options) {
		let optionVal = options[optionKey];
		switch (optionKey.toLowerCase()) {
			case "fields":
				queryString.set(
					"fields",
					assembleOptionsFields(optionVal).join(","),
				);
				break;
			case "where":
				queryString.set("where", assembleOptionsWhere(optionVal));
				break;
			case "join":
				queryString.set("join", assembleOptionsJoin(optionVal));
				break;
			case "ojoin":
				queryString.set("ojoin", assembleOptionsJoin(optionVal));
				break;
			case "sort":
				queryString.set("sort", assembleOptionsSort(optionVal));
				break;
			default:
				queryString.set(optionKey, optionVal);
		}
	}
	// Decode URI because URLSearchParams automatically encodes URI components
	return decodeURIComponent(queryString.toString());
}

function assembleOptionsFields(fields: any, prefix = ""): string[] {
	let output: any = [];

	for (let key in fields) {
		let value = fields[key];
		if (typeof value === "object") {
			let newPrefix = prefix + (isNaN(Number(key)) ? key : "") + ".";
			if (newPrefix == ".") {
				newPrefix = "";
			}
			if (newPrefix.slice(-2) === "..") {
				newPrefix = newPrefix.slice(0, -1);
			}
			output = output.concat(assembleOptionsFields(value, newPrefix));
		} else {
			output.push(prefix + value);
		}
	}

	return output;
}

function urlEncode(input: string, encodeSpecialChars: boolean = true): string {
	if (encodeSpecialChars && input && typeof input === "string") {
		input = input.replace(/[%&?,]/g, (match) => {
			return encodeURIComponent(match);
		});
		input = input.replace(/[!'()*\-._~]/g, function (c) {
			return "%" + c.charCodeAt(0).toString(16).toUpperCase();
		});
		return input;
	} else {
		return encodeURIComponent(input);
	}
}

function assembleOptionsWhere(input: Record<string, any>): string {
	let output = [];
	let operator = "and";
	for (let key in input) {
		let value = input[key];
		operator = key.toUpperCase();
		for (let fieldConditions of value) {
			if (typeof fieldConditions === "object") {
				for (let field in fieldConditions) {
					let conditions = fieldConditions[field];
					let childOperator = field.toUpperCase();
					if (childOperator === "AND" || childOperator === "OR") {
						output.push(assembleOptionsWhere(fieldConditions));
					} else {
						for (let comparison in conditions) {
							let conditionValue = conditions[comparison];
							comparison = comparison.replace(/<>/g, "ne");
							comparison = comparison.replace(/>=/g, "ge");
							comparison = comparison.replace(/>/g, "gt");
							comparison = comparison.replace(/<=/g, "le");
							comparison = comparison.replace(/</g, "lt");
							comparison = comparison.replace(/==/g, "eq");
							comparison = comparison.replace(/!=/g, "ne");
							comparison = comparison.replace(/=/g, "eq");
							comparison = comparison.replace(/not/g, "not");
							comparison = comparison.replace(/like/g, "like");
							comparison = comparison.replace(
								/contains/g,
								"contains",
							);
							comparison = comparison.replace(
								/starts/g,
								"starts",
							);
							comparison = comparison.replace(/ends/g, "ends");
							comparison = comparison.replace(
								/excludes/g,
								"excludes",
							);

							// Handling for IN & NOT IN
							/*if (comparison == "in" || comparison == "notin") {
								let inValues = [];
								for (let inValue of conditionValue) {
									inValues.push(urlEncode(inValue));
								}
								conditionValue = inValues.join(":");
							} else {
								conditionValue = urlEncode(conditionValue);
							}*/
							//Commenting this function as we are allowing multiple searches for table
							conditionValue = urlEncode(conditionValue);

							output.push(
								`${field}:${comparison}:${conditionValue}`,
							);
						}
					}
				}
			} else if (typeof fieldConditions === "string") {
				output.push(fieldConditions);
			}
		}
	}
	return `(${output.join(`,${operator},`)})`;
}

function assembleOptionsJoin(input: Record<string, any>): string {
	let out = [];
	for (let item of Object.values(input)) {
		let thisJoin = "";
		for (let table in item as Record<string, any>) {
			let value = (item as Record<string, any>)[table];
			thisJoin += table + ":";
			let thisJoinConditions = [];
			for (let fieldA in value as Record<string, any>) {
				let fieldB = (value as Record<string, any>)[fieldA];
				thisJoinConditions.push(fieldA + "=" + fieldB);
			}
			thisJoin += thisJoinConditions.join(";");
		}
		out.push(thisJoin);
	}
	return out.join(",");
}

function assembleOptionsSort(input: any) {
	return Object.keys(input).length === 0 ? "" : input.join(",");
}

export const getDataTableMeta = async (slug: string) => {
	interface Field {
		isCopyable: any;
		settings: Record<string, any>;
		index: number;
		slug: string;
		field: string;
		name: string;
		isVisible: boolean;
	}
	interface OutputType {
		table: {
			uuid: string;
			recordsPerPage: number;
			slug: string;
			name: string;
			route: string;
			sortPrimaryDirection: string;
			sortPrimaryTableViewFieldSlug: string;
			fields: Field[];
			apiWhereClause: string | null;
		} | null;
		fields: Array<{
			index: number;
			slug: string;
			field: string;
			name: string;
			isVisible: boolean;
		}>;
		nestedTable: any;
	}

	let output: OutputType = {
		table: null,
		fields: [],
		nestedTable: null,
	};

	/* ------------------------------------------ Get Meta ------------------------------------------ */
	let response = await togaApiRequest("GET", "/table-views/meta", null, {
		slug: slug,
	});

	if (!response.isSuccess) {
		return output;
	}

	output = response.data.tableViews.meta;

	/* -------------------------------- Get values for STATUS fields -------------------------------- */
	output.table.fields = await processStatusFields(output.table.fields);

	/*
	// FOR TESTING OUT getDataTableFieldSelectValues()
	const values = await getDataTableFieldSelectValues(output.table.fields[1]);
 	*/

	return output;
};

async function processStatusFields(fields) {
	let returnFields = [];

	for (const field of fields) {
		if (field.type === "STATUS") {
			const statusResponse = await togaApiRequest(
				"GET",
				"/" + field.recordRoute,
				null,
				{
					fields: ["slug", "name", "colorHex"],
					sort: ["sortOrder"],
				},
			);

			if (!statusResponse.isSuccess) {
				Sentry.captureMessage("processStatusFields", {
					level: "warning",
					tags: {
						errorType: "API",
					},
					extra: statusResponse,
				});
				continue; // skip to the next iteration if the response is not successful
			}

			// add the status fields to the field object using the slug as the key
			field.values = statusResponse.data[kebabToCamel(field.recordRoute)];
		}
		returnFields.push(field); // add the modified field to the statusFields array
	}

	return returnFields; // return the processed fields
}

/**
DETAILS ON getDataTableData USAGE

getDataTableData(dataTableMeta, nestedPrimaryRecordUuid)

dataTableMeta = The object returned from getDataTableMeta()

nestedPrimaryRecordUuid = UNDEFINED/NULL or <PARENT_UUID>   (see below for usage)

UNDEFINED/NULL
Returns all data, parent and nested, using query string parameters
Returns an array of data objects for each parent row. Each object has a "nestedRows" property which is an array of data objects for each nested row.
Returns an "index" property for each parent data object, and this is the index position in the main parent array.  It should be used for populating the query string when a child/nested attribute is defined, such as the sorting for a child/nested table of only one of the parent records.
QUERY PARAMETER USAGE
	<PARENT-TABLE-SLUG>_page = set the page number of the parent table to load, ie: 1
	<PARENT-TABLE-SLUG>_recordsPerPage = set the records per page of the parent table to return: ie: 5
	<PARENT-TABLE-SLUG>_sort[<SORT_INDEX>] = an array of sort columns for sorting the parent table, the first element is the primary sort, second is secondary sort, and so on.  defaults to ASCending, add a hyphen (-) on the beginning of the slug field for desending.  ie: -dateOrder
		ie: orders_sort[0]=-dateOrder&orders_sort[1]=number
			(this means sorting the orders parent table  = 2) by dateOrder descending and then by number ascending)
	<PARENT-TABLE-SLUG>_<PARENT-FIELD-SLUG> = searches for this value within the field (<PARENT-FIELD-SLUG>) of the parent table (<PARENT-TABLE-SLUG>)

<PARENT_UUID>

Returns data for only this parent UUID
Still returns a structure similar to using NULL, but only focusing on that one parent and the children
Query parameter usage is similar to parent tables but you must include the <INDEX> of the parent row in the query string.
<INDEX> is the numerical index of the nested table for that parent.
	ie, if the parent is showing 5 records and each record has its own nested table.  if you are referring to the 4th table on the page, then the <INDEX> would be 3 b/c it is 0-based
QUERY PARAMETER USAGE
	<CHILD-TABLE-SLUG>_page[<INDEX>] = set the page number of the parent table to load, ie: 1
	<CHILD-TABLE-SLUG>_recordsPerPage[<INDEX>] = set the records per page of the child table to return: ie: 5
	<CHILD-TABLE-SLUG>_sort[<INDEX>][<SORT_INDEX>] = an array of sort columns for sorting the child table, the first element is the primary sort, second is secondary sort, and so on.  defaults to ASCending, add a hyphen (-) on the beginning of the slug field for desending.  ie: -dateOrder
		ie: units_sort[2][0]=-serialNumber&units_sort[2][1]=date
			(this means sorting the units nested table of the 3rd nested table on the page (index = 2) by serialNumber descending and then by date ascending)
	<CHILD-TABLE-SLUG>_<PARENT-FIELD-SLUG>[<INDEX>] = searches for this value within the field (<PARENT-FIELD-SLUG>) of the parent table (<PARENT-TABLE-SLUG>)
*/

// VERSION 2 (10/5/2023 Jeff C) UPDATED ON 04/17/25 for InfiniteScroll Blake P.

export const getDataTableData = async (
	dataTableMeta: DataTableMetaType,
	nestedPrimaryRecordSlug: string | null,
	nestedPrimaryRecordUuid: string | null,
	additionalData: {
		page?: number;
		hasInfiniteScroll?: boolean;
		[key: string]: any;
	} = {},
	selectedPurchaseOrderItemUuid,
	subtableSlug,
	subtableUuid,
	extraFields: string[] = [],
): Promise<DataTableResponseType> => {
	// ── 0) guard
	if (!dataTableMeta.table) {
		throw new Error("Missing table metadata");
	}
	const table = dataTableMeta.table;
	const parentTableSlug = table.slug;
	const queryParams = getQueryParams();

	const isInfinite = Boolean(additionalData.hasInfiniteScroll);
	const incomingPage = Number(additionalData.page ?? 1);

	const options: OptionsType = {
		recordsPerPage: table.recordsPerPage,
		page: 1,
		sort: [],
	};

	if (extraFields.length > 0) {
		options.fields = ["uuid", ...extraFields];
	} else {
		options.fields = ["uuid"];
		for (const field of table.fields) {
			options.fields.push(field.tableViewField);
			if (field.hyperlinkField) options.fields.push(field.hyperlinkField);
			if (field.imageUrlField) options.fields.push(field.imageUrlField);
		}
		// remove any accidental duplicates
		options.fields = Array.from(new Set(options.fields));
	}

	if (isInfinite) {
		options.page = incomingPage;
		options.recordsPerPage = table.recordsPerPage;
	} else {
		const urlPage = queryParams[`${parentTableSlug}_page`];
		options.page = urlPage !== undefined ? Number(urlPage) : incomingPage;

		const urlRpp = queryParams[`${parentTableSlug}_recordsPerPage`];
		options.recordsPerPage =
			urlRpp !== undefined ? Number(urlRpp) : table.recordsPerPage;
	}

	const lookupTableViewFieldsBySlug: Record<string, string> = {
		uuid: "uuid",
	};
	if (extraFields.length === 0) {
		for (const field of table.fields) {
			options.fields.push(field.tableViewField);
			lookupTableViewFieldsBySlug[field.slug] = field.tableViewField;

			if (field.hyperlinkField) {
				options.fields.push(field.hyperlinkField);
				lookupTableViewFieldsBySlug[`${field.slug}_hyperlink`] =
					field.hyperlinkField;
			}
			if (field.imageUrlField) {
				options.fields.push(field.imageUrlField);
				lookupTableViewFieldsBySlug[`${field.slug}_imageUrl`] =
					field.imageUrlField;
			}
		}
	} else {
		for (const field of table.fields) {
			lookupTableViewFieldsBySlug[field.slug] = field.tableViewField;
			if (field.hyperlinkField) {
				lookupTableViewFieldsBySlug[`${field.slug}_hyperlink`] =
					field.hyperlinkField;
			}
			if (field.imageUrlField) {
				lookupTableViewFieldsBySlug[`${field.slug}_imageUrl`] =
					field.imageUrlField;
			}
		}
	}

	// ── 5) assemble joins
	if (table.joins?.length) {
		options.join = [];
		options.ojoin = [];
		for (const j of table.joins) {
			const key = j.type === "OUTER" ? "ojoin" : "join";
			options[key]!.push({
				[`${j.table}@${j.alias}`]: { [j.onA]: [j.onB] },
			});
		}
		if (options.join.length === 0) delete options.join;
		if (options.ojoin.length === 0) delete options.ojoin;
	}

	const baseRpp = Number(
		(isInfinite ? 100 : queryParams[parentTableSlug + "_recordsPerPage"]) ??
			15,
	);

	options.recordsPerPage = baseRpp;
	// add the sort (remember, sort is an array)
	if (queryParams.hasOwnProperty(parentTableSlug + "_sort[0]")) {
		// overriding sort requested, loop through each element until one is undefined
		for (
			let i = 0;
			queryParams.hasOwnProperty(parentTableSlug + "_sort[" + i + "]");
			i++
		) {
			const sort = queryParams[parentTableSlug + "_sort[" + i + "]"];
			let sortName = sort.trim();
			let sortDir = "";
			if (sort.startsWith("-") || sort.startsWith("+")) {
				sortName = sort.substring(1);
				sortDir = sort.charAt(0);
			}
			const field = dataTableMeta.table.fields.find(
				(item) => item.slug === sortName,
			);
			options.sort.push(sortDir + field?.tableViewField);
		}
	} else if (dataTableMeta?.table?.sort.length) {
		// no sort asked for... use default sort
		for (const sort of dataTableMeta.table.sort) {
			options.sort.push(
				(sort.dir == "DESC" ? "-" : "") +
					lookupTableViewFieldsBySlug[sort.slug],
			);
		}
	}

	// add the search
	for (const field of dataTableMeta.table.fields) {
		const baseKey = dataTableMeta.table.slug + "_" + field.slug;
		const operatorSuffixes = ["in", "starts", "ends", "between"];
		let searchKey: string, operatorVal: string;

		// 1) look for any suffix like `_in`, `_starts`, etc.
		for (const op of operatorSuffixes) {
			const keyWithOp = baseKey + "_" + op;
			if (queryParams[keyWithOp] !== undefined) {
				searchKey = keyWithOp;
				operatorVal = op;
				break;
			}
		}

		// 2) fallback to plain key + default operator
		if (!searchKey) {
			searchKey = baseKey;
			// if you’ve removed _operator from the URL, default directly to "contains"
			operatorVal = queryParams[baseKey + "_operator"] || "contains";
		}

		// 3) apply filter whenever the param exists
		if (queryParams[searchKey] !== undefined) {
			let rawValue = String(queryParams[searchKey]);

			const op = operatorVal || "contains";

			// TODO: REMOVE THIS AFTER UPDATING ALL FILTERS AND URL
			// this is to handle compass typing in 'pending initial approval' instead of 'pendingInitialApproval' and the filters should still work
			if (field.slug === "status" && parentTableSlug === "sales-orders") {
				rawValue = rawValue.replace(/\s+(.)/g, (match, char) =>
					char.toUpperCase(),
				);
				rawValue = rawValue.replace(/\s+/g, "");
			}
			const decodedRaw = decodeURIComponent(rawValue);

			//  Ensure the where-and array exists
			if (!options.where) options.where = {};
			if (!options.where.and) options.where.and = [];

			// Check if user entered comma-separated values - if so, build OR conditions
			if (decodedRaw.includes(",")) {
				// Split on comma, trim whitespace from each value
				const commaParts = decodedRaw
					.split(",")
					.map((value) => value.trim())
					.filter((value) => value);
				if (commaParts.length > 1) {
					// Build OR group with contains for each value
					const orConditions = commaParts.map((val) => ({
						[field.tableViewField]: { [op]: val },
					}));
					options.where.and.push({ or: orConditions });
				} else if (commaParts.length === 1) {
					options.where.and.push({
						[field.tableViewField]: { [op]: commaParts[0] },
					});
				}
			} else {
				// Split on ":" to support multiple values (existing behavior)
				const parts = decodedRaw
					.split(":")
					.map((piece) => piece.trim())
					.filter((piece) => piece);

				if (parts.length > 1) {
					// More than one search term, build an OR group
					const orConditions = parts.map((val) => ({
						[field.tableViewField]: { [op]: val },
					}));
					options.where.and.push({ or: orConditions });
				} else if (parts.length === 1) {
					// Only one search term, single-value condition
					options.where.and.push({
						[field.tableViewField]: { [op]: parts[0] },
					});
				}
			}
		}
	}

	// if we're searching by a nestedPrimaryRecordUuid, then add that to the where clause
	if (nestedPrimaryRecordUuid && !subtableSlug && !subtableUuid) {
		// ensure we have a { and: [] } bucket
		if (!options.where) {
			options.where = { and: [] };
		} else if (!Array.isArray(options.where.and)) {
			options.where.and = [];
		}

		options.where.and.push({
			// e.g. "SalesOrders.uuid": { like: "...-parent-uuid-…" }
			[`${
				nestedPrimaryRecordSlug
					? nestedPrimaryRecordSlug
					: dataTableMeta.table.table
			}.uuid`]: {
				like: nestedPrimaryRecordUuid,
			},
		});
	}

	if (
		nestedPrimaryRecordUuid &&
		selectedPurchaseOrderItemUuid &&
		!subtableSlug &&
		!subtableUuid
	) {
		// ensure we have a { and: [] } bucket
		if (!options.where) {
			options.where = { and: [] };
		} else if (!Array.isArray(options.where.and)) {
			options.where.and = [];
		}

		options.where.and.push(
			{
				"SalesOrderItems.uuid": {
					like: selectedPurchaseOrderItemUuid,
				},
			},
			{
				[`${
					nestedPrimaryRecordSlug
						? nestedPrimaryRecordSlug
						: dataTableMeta.table.table
				}.uuid`]: {
					like: nestedPrimaryRecordUuid,
				},
			},
		);
	}

	if (subtableSlug && subtableUuid) {
		// ensure we have a { and: [] } bucket
		if (!options.where) {
			options.where = { and: [] };
		} else if (!Array.isArray(options.where.and)) {
			options.where.and = [];
		}

		options.where.and.push({
			[`${subtableSlug ? subtableSlug : dataTableMeta.table.table}.uuid`]:
				{
					like: subtableUuid,
				},
		});
	}

	/* --------- Add additional conditions to the where clause from the additionalData object ------*/
	if (additionalData) {
		if (Array.isArray(additionalData)) {
			additionalData.forEach((filter) => {
				if (filter && filter.slug && filter.uuid) {
					if (options.where === undefined) {
						options.where = {};
					}
					if (options.where.and === undefined) {
						options.where.and = [];
					}
					if (
						filter.slug === "catalogId" ||
						filter.slug === "customerId" ||
						filter.slug === "Items.catalogId" ||
						filter.slug === "vendorId" || // flat vendor filter
						filter.slug === "Items.vendorId" // nested vendor filter
					) {
						options.where.and.push({
							[filter.slug]: {
								like: filter.uuid,
							},
						});
					} else {
						options.where.and.push({
							[filter.slug + ".uuid"]: {
								like: filter.uuid,
							},
						});
					}
				}
			});
		} else if (additionalData.slug && additionalData.uuid) {
			// fallback if additionalData was passed as an object
			if (options.where === undefined) {
				options.where = {};
			}
			if (options.where.and === undefined) {
				options.where.and = [];
			}
			if (
				additionalData.slug === "catalogId" ||
				additionalData.slug === "customerId" ||
				additionalData.slug === "Items.catalogId" ||
				additionalData.slug == "SalesOrderItems.uuid" ||
				additionalData.slug == "SalesOrders.uuid"
			) {
				options.where.and.push({
					[additionalData.slug]: {
						like: additionalData.uuid,
					},
				});

				if (
					additionalData.slug == "customerId" &&
					hostName[0] == "NYCHH"
				) {
					options.where.and.push({
						["_total"]: {
							ne: 0,
						},
					});
				}
			} else {
				options.where.and.push({
					[additionalData.slug + ".uuid"]: {
						like: additionalData.uuid,
					},
				});
			}
		}
	}

	//TODO - ADD 2 SalesOrder Stages here
	// ── Sales-order stages filter
	if (additionalData._status) {
		// ensure where.and exists
		if (!options.where) {
			options.where = { and: [] };
		} else if (!Array.isArray(options.where.and)) {
			options.where.and = [];
		}

		const orConditions = additionalData._status.map((status) => ({
			_status: { like: status },
		}));

		options.where.and.push({ or: orConditions });

		if (additionalData.userUuid) {
			options.where.and.push({
				"Users_B.uuid": { like: additionalData.userUuid },
			});
		}
	}

	//TODO - ADD isQuote
	if (!additionalData.isQuote && additionalData.isQuote !== undefined) {
		if (!options.where) {
			options.where = {};
		}
		if (!options.where.and) {
			options.where.and = [];
		}
		options.where.and.push({
			isQuote: {
				eq: additionalData.isQuote,
			},
		});
	}

	// if apiWhereClause is defined, then we need to add it to the where clause as a literal string
	if (table.apiWhereClause) {
		if (!options.where) {
			options.where = {};
		}
		if (!options.where.and) {
			options.where.and = [];
		}
		options.where.and.push(table.apiWhereClause);
	}

	/* ---------------------------------- Fetch Parent Record Data ---------------------------------- */

	const parentResponse = await togaApiRequest(
		"GET",
		dataTableMeta.table.route,
		null,
		options,
	);

	if (!parentResponse.isSuccess) {
		Sentry.captureMessage("parentResponse", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: parentResponse,
		});

		return; // early return if parentResponse is not successful
	}

	/* ----------------------------------- Process Each Parent Row ---------------------------------- */
	interface Output {
		meta: Meta;
		rows: Row[];
	}
	let output: OutPut = {
		meta: parentResponse.meta,
		rows: [],
	};

	const parentRows =
		parentResponse.data[
			kebabToCamel(dataTableMeta.table.route.substring(1))
		];

	for (const index in parentRows) {
		const parentRow = parentRows[index];

		let thisOutputParentRow = {
			data: {},
		};

		/* --------------------------------- NESTED TABLE DATA FETCHING --------------------------------- */
		if (dataTableMeta.nestedTable) {
			// there is a nested table for this, so we need to build and submit each nested API call
			const nestedTableSlug = dataTableMeta.nestedTable?.slug;

			thisOutputParentRow.nested = {
				meta: {},
				rows: [],
			};

			/* ---------------------------------- Assemble Nested API Call ---------------------------------- */

			// define default options
			let nestedOptions: OptionsType = {
				fields: ["uuid"],
				recordsPerPage: dataTableMeta.nestedTable.recordsPerPage,
				page: 1,
				sort: [],
			};

			// add the nested fields and build lookupTableViewSlugsByApiField
			let lookupNestedTableViewFieldsBySlug: { [key: string]: string } = {
				uuid: "uuid",
			};
			dataTableMeta.nestedTable.fields.map((field) => {
				nestedOptions.fields.push(field.tableViewField);
				lookupNestedTableViewFieldsBySlug[field.slug] =
					field.tableViewField;
			});

			// add the nested joins
			if (dataTableMeta.nestedTable.joins.length) {
				nestedOptions.ojoin = [];
				dataTableMeta.nestedTable.joins.map((join) => {
					nestedOptions.ojoin.push({
						[join.table + "@" + join.alias]: {
							[join.onA]: [join.onB],
						},
					});
				});
				if (nestedOptions.ojoin.length === 0) {
					delete nestedOptions.ojoin;
				}
			}

			// add the page
			if (
				queryParams[nestedTableSlug + "_page[" + index + "]"] !==
				undefined
			) {
				nestedOptions.page = Number(
					queryParams[nestedTableSlug + "_page[" + index + "]"],
				);
			} else if (queryParams[nestedTableSlug + "_page"] !== undefined) {
				nestedOptions.page = Number(
					queryParams[nestedTableSlug + "_page"],
				);
			}

			// add the recordsPerPage
			if (
				queryParams[
					nestedTableSlug + "_recordsPerPage[" + index + "]"
				] !== undefined
			) {
				nestedOptions.recordsPerPage = Number(
					queryParams[
						nestedTableSlug + "_recordsPerPage[" + index + "]"
					],
				);
			} else if (
				queryParams[nestedTableSlug + "_recordsPerPage"] !== undefined
			) {
				nestedOptions.recordsPerPage = Number(
					queryParams[nestedTableSlug + "_recordsPerPage"],
				);
			}

			// add the sort (remember, sort is an array)
			if (
				queryParams[nestedTableSlug + "_sort[" + index + "][0]"] !==
				undefined
			) {
				// overriding sort requested
				for (
					let i = 0;
					queryParams.hasOwnProperty(
						nestedTableSlug + "_sort[" + index + "][" + i + "]",
					);
					i++
				) {
					const sort =
						queryParams[
							nestedTableSlug + "_sort[" + index + "][" + i + "]"
						];

					let sortSlug = sort.trim();
					let sortDir = "";
					if (sort.startsWith("-") || sort.startsWith("+")) {
						sortSlug = sort.substring(1);
						sortDir = sort.charAt(0);
					}
					nestedOptions.sort.push(
						sortDir + lookupNestedTableViewFieldsBySlug[sortSlug],
					);
				}
			} else if (
				queryParams[nestedTableSlug + "_sort[0]"] !== undefined
			) {
				// overriding sort requested
				for (
					let i = 0;
					queryParams.hasOwnProperty(
						nestedTableSlug + "_sort[" + i + "]",
					);
					i++
				) {
					const sort =
						queryParams[nestedTableSlug + "_sort[" + i + "]"];

					let sortSlug = sort.trim();
					let sortDir = "";

					if (sort.startsWith("-") || sort.startsWith("+")) {
						sortSlug = sort.substring(1);
						sortDir = sort.charAt(0);
					}
					nestedOptions.sort.push(
						sortDir + lookupNestedTableViewFieldsBySlug[sortSlug],
					);
				}
			} else {
				// no sort asked for... use default sort
				for (const sort of dataTableMeta.nestedTable.sort) {
					nestedOptions.sort.push(
						(sort.dir == "DESC" ? "-" : "") +
							lookupNestedTableViewFieldsBySlug[sort.slug],
					);
				}
			}

			// add the search
			for (const field of dataTableMeta.nestedTable.fields) {
				const candidateSearchParam =
					dataTableMeta?.nestedTable?.slug + "_" + field.slug;
				if (
					queryParams[candidateSearchParam + "[" + index + "]"] !==
					undefined
				) {
					// found a search parameter on this field, add it to the API call
					if (nestedOptions.where == undefined) {
						nestedOptions.where = [];
					}
					// @ts-ignore
					if (nestedOptions.where.and == undefined) {
						// @ts-ignore
						nestedOptions.where.and = [];
					} // @ts-ignore
					nestedOptions.where.and.push({
						[field.tableViewField]: {
							contains:
								queryParams[
									candidateSearchParam + "[" + index + "]"
								],
						},
					});
				}
			}

			// add the nested relationships
			for (const parentField in dataTableMeta.nestedTable.relationships) {
				const nestedField =
					dataTableMeta.nestedTable.relationships[parentField];
				if (nestedOptions.ojoin === undefined) {
					nestedOptions.ojoin = [];
				}

				// add the nested join
				nestedOptions.ojoin.push({
					[dataTableMeta.table.table]: {
						[dataTableMeta.table.table + "." + parentField]: [
							dataTableMeta.nestedTable.table + "." + nestedField,
						],
					},
				});

				if (nestedOptions.ojoin.length === 0) {
					delete nestedOptions.ojoin;
				}

				// add the nested where condition for filtering by the parent uuid
				if (nestedOptions.where == undefined) {
					nestedOptions.where = [];
				}

				if (nestedOptions.where.and == undefined) {
					// @ts-ignore
					nestedOptions.where.and = [];
				} // @ts-ignore
				nestedOptions.where.and.push({
					[dataTableMeta.table.table + ".uuid"]: {
						like: parentRow.uuid,
					},
				});
			}

			/* ---------------------------------- Fetch Nested Record Data ---------------------------------- */
			const nestedResponse = await togaApiRequest(
				"GET",
				dataTableMeta.nestedTable.route,
				null,
				nestedOptions,
			);
			if (!nestedResponse.isSuccess) {
				Sentry.captureMessage("nestedResponse", {
					level: "warning",
					tags: {
						errorType: "API",
					},
					extra: nestedResponse,
				});
				return; // early return if nestedResponse is not successful
			}

			/* ----------------------------------- Process Each Nested Row ---------------------------------- */
			const nestedRows =
				nestedResponse.data[
					kebabToCamel(dataTableMeta.nestedTable.route.substring(1))
				];

			thisOutputParentRow.nested.meta = nestedResponse.meta;
			for (const nestedRow of nestedRows) {
				let thisOutputNestedRow = {
					data: {
						uuid: nestedRow.uuid,
					},
				};

				// map the returned parent API fields into the output object
				for (const fieldMeta of dataTableMeta.nestedTable.fields) {
					let fieldValue = null;
					if (fieldMeta.tableViewField.indexOf(".") == -1) {
						fieldValue = nestedRow[fieldMeta.tableViewField];
					} else {
						const [table, field] =
							fieldMeta.tableViewField.split(".");
						fieldValue = nestedRow[table][field];
					}
					thisOutputNestedRow.data[fieldMeta.slug] = fieldValue;
				}

				// populate the nested data within the parent row
				thisOutputParentRow.nested.rows.push(thisOutputNestedRow);
			}
		}

		// map the returned parent API fields into the output object
		thisOutputParentRow.data.uuid = parentRow.uuid;

		for (const fieldMeta of dataTableMeta.table.fields) {
			let fieldValue = null;
			if (fieldMeta.tableViewField.indexOf(".") == -1) {
				fieldValue = parentRow[fieldMeta.tableViewField];
			} else {
				const [table, field] = fieldMeta.tableViewField.split(".");
				fieldValue = parentRow[table][field];
			}
			thisOutputParentRow.data[fieldMeta.slug] = fieldValue;

			// hyperlink
			if (fieldMeta.hyperlinkField) {
				if (fieldMeta.hyperlinkField.indexOf(".") == -1) {
					fieldValue = parentRow[fieldMeta.hyperlinkField];
				} else {
					const [table, field] = fieldMeta.hyperlinkField.split(".");
					fieldValue = parentRow[table][field];
				}
				thisOutputParentRow.data[fieldMeta.slug + "_hyperlink"] =
					fieldValue;
			}

			// imageUrl
			if (fieldMeta.imageUrlField) {
				if (fieldMeta.imageUrlField.indexOf(".") == -1) {
					fieldValue = parentRow[fieldMeta.imageUrlField];
				} else {
					const [table, field] = fieldMeta.imageUrlField.split(".");
					fieldValue = parentRow[table][field];
				}
				thisOutputParentRow.data[fieldMeta.slug + "_imageUrl"] =
					fieldValue;
			}
		}

		output.rows.push(thisOutputParentRow);
	}

	return output;
};

/**
 * Fetches values for a SELECT field type.  This should be used for populating dropdowns.
 * Pass the field meta object to this function.
 *	Example:
		const values = await getDataTableFieldSelectValues(output.table.fields[1]);
 * @param slug
 */
export const getDataTableFieldSelectValues = async (
	dataTableFieldMeta: DataTableFieldMetaType,
) => {
	if (
		dataTableFieldMeta.type === "SELECT" &&
		dataTableFieldMeta.recordRoute &&
		dataTableFieldMeta.selectIdentifierField &&
		dataTableFieldMeta.selectNameField
	) {
		let values = [];
		let totalPages = 1;
		for (let page = 1; page <= totalPages; ++page) {
			let response = await togaApiRequest(
				"GET",
				"/" + dataTableFieldMeta.recordRoute,
				null,
				{
					recordsPerPage: 1000,
					page: page,
					fields: [
						dataTableFieldMeta.selectIdentifierField,
						dataTableFieldMeta.selectNameField,
					],
					sort: [dataTableFieldMeta.selectNameField],
				},
			);

			if (response.isSuccess) {
				totalPages = response.meta.totalPageCount;

				// add the response data values to the values array, making sure to use id and name as the two values for the key pair
				values = values.concat(
					response.data[
						kebabToCamel(dataTableFieldMeta.recordRoute)
					].map((item) => {
						return {
							id: item[dataTableFieldMeta.selectIdentifierField],
							name: item[dataTableFieldMeta.selectNameField],
						};
					}),
				);
			}
		}

		return values;
	}
	return [];
};

export const getPageMeta = async (page: string) => {
	let response = await togaApiRequest("GET", "/pages/meta", null, {
		page: page,
		app: "supply",
	});
	if (!response.isSuccess) {
		Sentry.captureMessage("getPageMeta", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
		return;
	}
	return response.data.pages.meta;
};

//Get Event Logs data
export const getEventLogs = async (route: string, uuid: string) => {
	const options = {
		route: route,
		uuid: uuid,
	};
	let response = await togaApiRequest(
		"GET",
		"/record-logs/lookup",
		null,
		options,
	);
	if (!response.isSuccess) {
		Sentry.captureMessage("recordLogs", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
		return;
	}
	return response.data.recordLogs.lookup.recordLogs;
};

//Function to check the differences between original and updated payload data
export const checkForDifferences = (originalData, modifiedData) => {
	const differences = {};

	const compareValues = (key, origVal, modVal) => {
		// Handling explicitly for empty strings
		if (modVal === "" && (origVal === undefined || origVal === "")) {
			// If the new value is an empty string and original was also empty or undefined, ignore it
			return undefined;
		} else if (modVal === "" && origVal !== "") {
			// If new value is an empty string and original was not, mark as cleared
			return "__cleared";
		}

		if (Array.isArray(origVal) && Array.isArray(modVal)) {
			if (JSON.stringify(origVal) !== JSON.stringify(modVal)) {
				return modVal; // Return the modified array if different
			}
		} else if (
			typeof origVal === "object" &&
			origVal !== null &&
			typeof modVal === "object" &&
			modVal !== null
		) {
			const diff = compareObjects(origVal, modVal);
			if (Object.keys(diff).length > 0) {
				return diff;
			}
		} else if (origVal !== modVal) {
			return modVal;
		}
		return undefined;
	};

	const compareObjects = (orig, mod) => {
		const diffs = {};
		const allKeys = new Set([...Object.keys(orig), ...Object.keys(mod)]);
		allKeys.forEach((key) => {
			const origVal = orig[key];
			const modVal = mod[key];
			const result = compareValues(key, origVal, modVal);
			if (result !== undefined) {
				diffs[key] = result;
			}
		});
		return diffs;
	};

	// Compare the top-level objects
	return compareObjects(originalData, modifiedData);
};

export async function getTableViewGroupsByTableViewSlug(
	tableViewSlug: string,
): TableViewGroup[] {
	//call the API, joining TableViews so we can filter by slug
	const resp = await togaApiRequest("GET", "/table-view-groups", null, {
		// join the TableViews table on its PK → the FK in table-view-groups
		join: [
			{
				TableViews: {
					"TableViews.id": "TableViewGroups.tableViewId",
				},
			},
		],
		// TODO - The where condition is not working as intended
		// where: {
		// 	and: [{ "TableViews.slug": { eq: tableViewSlug } }],
		// },
	});

	// unwrap whether the API returned a top-level array or wrapped in data.tableViewGroups
	if (Array.isArray(resp)) {
		return resp as TableViewGroup[];
	}
	if (
		resp?.data?.tableViewGroups &&
		Array.isArray(resp.data.tableViewGroups)
	) {
		return resp.data.tableViewGroups as TableViewGroup[];
	}
	return [];
}

// function for default table-view groups
export async function getDefaultTableViewGroups(
	pageId: number,
): TableViewGroup[] {
	const response = await togaApiRequest(
		"GET",
		"/pages-default-table-view-groups",
		null,
		{
			// fetch the two columns
			fields: ["tableViewGroup.uuid", "tableViewGroup.tableView.slug"],
			// TODO - Fix the where clause to work for all pages based on the pageId
			// where: { and: [{ 'pageId': { eq: pageId } }] },
		},
	);
	return response.data?.pagesDefaultTableViewGroups || [];
}

// Fetch default table-view groups for a page by slug (resolves slug → ID, then queries groups)
export async function fetchDefaultGroupsByPageSlug(
	pageSlug: string,
	appName: string = "supply",
): Promise<TableViewGroup[]> {
	const { id } = await getPageMeta(pageSlug, appName);
	return getDefaultTableViewGroups(id); // fetches default groups for the page ID
}

// Function to copy all values from a specific column in a table view
export function copyAllColumnValues(
	tableViewSlug: string,
	targetFields: string[],
	rowDelimiter: string = "\n",
	onSuccess: (result: { text: string; values: string[] }) => void,
	onFailure?: (error: unknown) => void,
	fieldSeparator: string = "\t",
) {
	getDataTableMeta(tableViewSlug)
		.then((tableMeta) => {
			if (!tableMeta || !tableMeta.table) {
				throw new Error("Missing table metadata for " + tableViewSlug);
			}

			// Map each requested field
			type fieldMap = { apiPath: string; dataKey: string };
			const fieldMaps: fieldMap[] = targetFields.map((targetField) => {
				const bySlug = tableMeta.table.fields.find(
					(field: any) => field.slug === targetField,
				);
				if (bySlug) {
					return {
						apiPath: bySlug.tableViewField,
						dataKey: bySlug.slug,
					};
				}
				const byApi = tableMeta.table.fields.find(
					(field: any) =>
						String(field.tableViewField || "").toLowerCase() ===
						String(targetField).toLowerCase(),
				);
				if (!byApi)
					throw new Error(
						`Field not found in meta for "${targetField}"`,
					);
				return { apiPath: String(targetField), dataKey: byApi.slug };
			});

			const apiPaths = fieldMaps.map((fieldMap) => fieldMap.apiPath);

			const lines: string[] = [];
			let pageIndex = 1;
			let totalPages = 1;

			function fetchNext() {
				getDataTableData(
					tableMeta,
					null, // nestedPrimaryRecordSlug
					null, // nestedPrimaryRecordUuid
					{ page: pageIndex, hasInfiniteScroll: true },
					undefined,
					undefined,
					undefined,
					apiPaths, // only request needed fields
				)
					.then((page) => {
						if (!page || !page.meta || !Array.isArray(page.rows)) {
							onSuccess({
								text: lines.join(rowDelimiter),
								values: lines,
							});
							return;
						}

						totalPages = Number(page.meta.totalPageCount || 1);

						for (const row of page.rows) {
							const escapeCell = (s: unknown) =>
								String(s ?? "")
									.replaceAll(rowDelimiter, " ")
									.replaceAll(fieldSeparator, " ")
									.trim();
							const cellStrings = fieldMaps.map(({ dataKey }) => {
								const rawData = row?.data?.[dataKey];
								if (rawData == null) return "";
								if (Array.isArray(rawData)) {
									return rawData
										.map((value) => escapeCell(value))
										.join(",");
								}
								return escapeCell(rawData);
							});

							const rowString = cellStrings.join(fieldSeparator);
							lines.push(rowString);
						}

						pageIndex += 1;
						if (pageIndex <= totalPages) {
							fetchNext();
						} else {
							onSuccess({
								text: lines.join(rowDelimiter),
								values: lines,
							});
						}
					})
					.catch((err: unknown) => onFailure && onFailure(err));
			}

			fetchNextPage();
		})
		.catch((err: unknown) => onFailure && onFailure(err));
}
